'use strict';

angular.module('shiftTraderApp')
  .controller('MwpEmployeeListCtrl', function ($scope, $uibModalInstance, params,
                                                  workPeriods, TimeService, AvailabilityRules,
                                                  AvailabilitySets, Users, $q, $timeout,
                                                  WeekCalculationService, WorkPeriodStore,
                                                  MWPCompositeAvailabilityService) {
    //console.log(window.performance.now(), 'MwpEmployeeListCtrl init');
    $scope.me = params.me;
    $scope.org = params.org;
    $scope.dates = params.dates;
    $scope.workPeriods = _.where(workPeriods, function(wp) {
      return wp.active;
    });
    $scope.allUsers = params.users;
    $scope.nowTime = TimeService.getNowInStoreTime();

    $scope.subtitle = $scope.dates[0].format('MMM D') + ' to ' + $scope.dates[6].format('MMM D');

    var weekRange = params.businessWeek;
    var calendarWeek = params.calendarWeek;
    var lastWeekRange = moment(weekRange.start).subtract(1, 'week').twix(weekRange.start);

    $scope.weekRange = calendarWeek;
    $scope.adjustedWeekRange = weekRange;

    $scope.sortFieldOptions = [
      {
        value: '-_sorting.laborHours',
        label: 'Most to Least Hours This Week'
      },
      {
        value: '+_sorting.laborHours',
        label: 'Least to Most Hours This Week'
      },
      {
        value: '+_sorting.firstName',
        label: 'A-Z Employee First Name'
      },
      {
        value: '-_sorting.firstName',
        label: 'Z-A Employee First Name'
      },
      {
        value: '-_sorting.lastWeekLaborHours',
        label: 'Most to Least Hours Previous Week'
      },
      {
        value: '+_sorting.lastWeekLaborHours',
        label: 'Least to Most Hours Previous Week'
      },
      {
        value: '-_sorting.weekHoursDelta',
        label: 'Most to Least Weekly Hours Difference'
      },
      {
        value: '+_sorting.weekHoursDelta',
        label: 'Least to Most Weekly Hours Difference'
      },
      {
        value: '-_sorting.targetHoursDelta',
        label: 'Most to Least Target Hours Difference'
      },
      {
        value: '+_sorting.targetHoursDelta',
        label: 'Least to Most Target Hours Difference'
      }

    ];

    $scope.state = {
      sortField: '-_sorting.laborHours',
      compositeAvailabilityLoaded: false,
      anyDaysInPast: $scope.nowTime.isAfter(calendarWeek.start)
    };

    $scope.close = function() {
      $uibModalInstance.dismiss();
    };

    if ($scope.state.anyDaysInPast) {
      MWPCompositeAvailabilityService.getCompositeAvailability(moment($scope.weekRange.start).subtract(1, 'days'), moment($scope.weekRange.end))
        .then(function(compositeAvailabilityData) {
          if (compositeAvailabilityData) {
            $scope.compositeAvailability = compositeAvailabilityData;

            _.each($scope.allUsers, function(u, idx) {
              $scope.allUsers[idx].$mergeInAvailability($scope.compositeAvailability);
            });

            $scope.state.compositeAvailabilityLoaded = true;
          }
        }, function() {

        });
    }

    $scope.userStatsByUserId = {};

    var setupSortingForUser = function(u) {
      var weekHoursDelta = Math.abs($scope.userStatsByUserId[u.id].laborHours - $scope.userStatsByUserId[u.id].lastWeekLaborHours);
      var targetHoursDelta = _.max(_.map($scope.userStatsByUserId[u.id].targetHoursData, function(target) {
        return Math.abs($scope.userStatsByUserId[u.id].laborHours - target.target_hours);
      }));

      u._sorting = {
        firstName: u.first_name + ' ' + u.last_name,
        lastName: u.last_name + ' ' + u.first_name,
        laborHours: $scope.userStatsByUserId[u.id].laborHours,
        lastWeekLaborHours: $scope.userStatsByUserId[u.id].lastWeekLaborHours,
        weekHoursDelta: weekHoursDelta,
        targetHoursDelta: targetHoursDelta
      };
    };


    var initUserStatData = function(u) {
      var targetHoursData = _.map(_.sortBy(_.where(u.availability_sets, function(availSet) {
        return (availSet.$isInEffect($scope.dates[0]) || availSet.$isInEffect($scope.dates[6])) && availSet.$isApproved()
      }), function(availSet) {
        return -1 * availSet.effective_date.unix();
      }), function(availSet) {
        return availSet;
      });

      $scope.userStatsByUserId[u.id] = {
        laborHours: 0,
        lastWeekLaborHours: 0,
        targetHours: (function() {
          var activeSet = _.find(u.availability_sets, function(availSet) {
            return availSet.$isInEffect($scope.dates[0]) && availSet.$isApproved();
          });

          if (activeSet) {
            return activeSet.target_hours;
          } else {
            return null;
          }
        })(),
        workPeriods: [],
        lastWeekWorkPeriods: [],
        prevWeekDayWorkPeriods: [],
        targetHoursData: targetHoursData
      };

    };

    var userIdsToFetchDataFor = [];

    var lastWeekWorkPeriodTimeframe = TimeService.getWeekTwixFromMoment(moment($scope.dates[0]).subtract(1, 'week'), 1, 0, true);
    WorkPeriodStore.getWorkPeriodsBetween(
      lastWeekWorkPeriodTimeframe.start,
      lastWeekWorkPeriodTimeframe.end)
      .then(function(wps) {
        $scope.lastWeekWorkPeriods = _.where(wps, function(wp) {
          return wp.active;
        });

        _.each($scope.lastWeekWorkPeriods, function(wp) {
          if (wp.$isAssigned()) {
            userIdsWithWorkPeriods.push(wp.user.id);
            if (_.isUndefined($scope.userStatsByUserId[wp.user.id])) {
              initUserStatData({id: wp.user.id, availability_sets: []});
              userIdsToFetchDataFor.push(wp.user.id);
            }

            if (lastWeekRange.overlaps(wp.range_twix)) {
              $scope.userStatsByUserId[wp.user.id].lastWeekLaborHours += Math.abs(lastWeekRange.intersection(wp.range_twix).length('minutes')) / 60.0;
              $scope.userStatsByUserId[wp.user.id].lastWeekWorkPeriods.push(wp);
            }
          }
        });

        _.each($scope.userStatsByUserId, function(userStats, userId) {
          // key is a string, convert back to integer
          userId = parseInt(userId);
          // put workPeriods in start order ASC
          userStats.lastWeekWorkPeriods = _.sortBy(userStats.lastWeekWorkPeriods, function (wp) {
            return wp.start_time.unix();
          });

          userStats.lastWeekLaborHours = _.reduce(_.map(userStats.lastWeekWorkPeriods, function (wp) {
            if (wp.range_twix.overlaps(lastWeekRange)) {
              return Math.abs(wp.range_twix.intersection(lastWeekRange).length('minutes')) / 60.0;
            } else {
              return 0;
            }
          }), function (sum, num) {
            return sum + num;
          }, 0);

          var user = _.find($scope.allUsers, {id: userId});
          if (user) {
            user._lastWeekLaborHours = $scope.userStatsByUserId[user.id].lastWeekLaborHours;
            setupSortingForUser(user);
          }
        });
      }, function() {
        console.log('last week load failed');
      });

    _.each($scope.allUsers, function(u) {
      initUserStatData(u);
    });

    var fetchDataForUser = function(userId) {
      Users.getById(userId)
        .then(function(user) {
          $scope.userStatsByUserId[user.id].targetHoursData = _.map(_.sortBy(_.where(user.availability_sets, function(availSet) {
            return (availSet.$isInEffect($scope.dates[0]) || availSet.$isInEffect($scope.dates[6])) && availSet.$isApproved()
          }), function(availSet) {
            return -1 * availSet.effective_date.unix();
          }), function(availSet) {
            return availSet;
          });

          user._laborHours = $scope.userStatsByUserId[user.id].laborHours;
          user._lastWeekLaborHours = $scope.userStatsByUserId[user.id].lastWeekLaborHours;

          // setup sorting for the new user entry

          setupSortingForUser(user);

          $scope.userStatsByUserId[user.id].target_hours = (function() {
            var activeSet = _.find(user.availability_sets, function(availSet) {
              return availSet.$isInEffect($scope.dates[0]) && availSet.$isApproved();
            });

            if (activeSet) {
              return activeSet.target_hours;
            } else {
              return null;
            }
          })();

          $scope.allUsers.push(user);

          // get additional availability for user
          (_.last($scope.allUsers)).$getCompositeAvailability(moment($scope.weekRange.start).subtract(1, 'days'), moment($scope.weekRange.end))
            .then(function(data) {
              if (data) {

                $scope.userStatsByUserId[user.id].target_hours = (function() {
                  var activeSet = _.find(user.availability_sets, function(availSet) {
                    return availSet.$isInEffect($scope.dates[0]) && availSet.$isApproved();
                  });

                  if (activeSet) {
                    return activeSet.target_hours;
                  } else {
                    return null;
                  }
                })();

                setupSortingForUser(user);

                console.log('$getCompositeAvailability for UserId', user.id, ' returned data', data);
                $scope.$broadcast('sa:saEmployeeWeekGrid:mwpEmployeeListModal', {userId: user.id});
              }
            });
        });
    };

    var userIdsWithWorkPeriods = [];

    _.each($scope.workPeriods, function(wp) {
      if (wp.$isAssigned()) {
        userIdsWithWorkPeriods.push(wp.user.id);
        if (_.isUndefined($scope.userStatsByUserId[wp.user.id])) {
          initUserStatData({id: wp.user.id, availability_sets: []});
          fetchDataForUser(wp.user.id);
        }

        $scope.userStatsByUserId[wp.user.id].laborHours += Math.abs(weekRange.intersection(wp.range_twix).length('minutes')) / 60.0;
        if (weekRange.overlaps(wp.range_twix)) {
          $scope.userStatsByUserId[wp.user.id].workPeriods.push(wp);
        } else if (!wp.start_time.isAfter(weekRange.end) && !wp.start_time.isSame(weekRange.end)) {
          $scope.userStatsByUserId[wp.user.id].prevWeekDayWorkPeriods.push(wp);
        }
      }
    });

    _.each($scope.userStatsByUserId, function(userStats, userId) {
      // key is a string, convert back to integer
      userId = parseInt(userId);
      // put workPeriods in start order ASC
      userStats.workPeriods = _.sortBy(userStats.workPeriods, function(wp) {
        return wp.start_time.unix();
      });

      userStats.laborHours = _.reduce(_.map(userStats.workPeriods, function(wp) {
        if (wp.range_twix.overlaps(weekRange)) {
          return Math.abs(wp.range_twix.intersection(weekRange).length('minutes')) / 60.0;
        } else {
          return 0;
        }

      }), function(sum, num) {
        return sum + num;
      }, 0);

      var user = _.find($scope.allUsers, {id: userId});
      if (user) {
        user._laborHours = userStats.laborHours;
        setupSortingForUser(user);
      }


      // group the shifts by day of week for that user
      userStats.workPeriodsByDay = [[],[],[],[],[],[],[]];
      _.each(userStats.workPeriods, function(wp) {
        var dateIndex = _.findIndex($scope.dates, function(dt) {
          var twx = dt.twix(moment(dt).add(1, 'day').hour(0));
          return twx.contains(wp.start_time) || wp.start_time.isSame(dt);
        });

        if (dateIndex > -1) {
          userStats.workPeriodsByDay[dateIndex].push(wp);
        }
      });

    });

    var calculateWeekStats = function() {
      $scope.workPeriodOverlapsByDay = _.map($scope.dates, function(dt) {
        var dtTwix = moment(dt).twix(moment(dt).add(1, 'days'));

        return _.where(workPeriods, function(wp) {
          return wp.range_twix.overlaps(dtTwix) &&
            Math.abs(wp.range_twix.intersection(dtTwix).length('minutes')) > 0;

        });
      });

      $scope.dayAnalysisDataByDay = WeekCalculationService.calcWeekWorkPeriodStats($scope.dates,
        $scope.workPeriodOverlapsByDay,
        $scope.org.departments, $scope.org);

      $scope.allDepartments = _.map(_.cloneDeep($scope.org.departments), function(dept) {
        dept._selected = true;
        return dept;
      });
    };

    var calculateSummaryData = function() {
      var selectedDeptIds = _.pluck(_.where($scope.allDepartments, {_selected: true}), 'id');
      $scope.state.numDepartmentsSelected = selectedDeptIds.length;

      // for each day aggregate the properties over selected departments
      $scope.statsDataByDay = _.map($scope.dayAnalysisDataByDay, function(day, idx) {
        var temp = {};
        temp.id = idx;
        temp.dateTwix = day.dateTwix;
        _.forEach(['numUnassignedUnpublishedWorkPeriodsStartingToday',
                   'numAssignedUnpublishedWorkPeriodsStartingToday',
                   'numAssignedPublishedWorkPeriodsStartingToday',
                   'numAssignedWorkPeriodsStartingToday',
                   'totalAssignedLaborHours'], function(prop) {
          temp[prop] = _.reduce(_.pick(day.departmentData, selectedDeptIds), function(accum, deptData) {
            return accum + deptData[prop];
          }, 0);
        });

        return temp;
      });
    };

    calculateWeekStats();
    calculateSummaryData();

    $scope.getUser = function(userId) {
      return _.find($scope.allUsers, {id: userId});
    };

    $timeout(function() {
      //console.log(window.performance.now(), 'fetch users timeout');
      _.each(userIdsToFetchDataFor, function(userId) {
        fetchDataForUser(userId);
      });
    }, 250);

    //console.log(window.performance.now(), 'MwpEmployeeListCtrl end of script');
  });
